import React, { useMemo } from 'react'
import Lottie from "lottie-react"
/* import success from '../../../assets/images/lottie/success.gif'; */
/* import success from './assets/images/lottie/sucess.gif'; */
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

function SuccessPage() {

    const history = useHistory();

    useMemo(() => {
        setTimeout(() => {
            history.push("/");
        }, 25000)
    })

    return (
        <div className='container' >
            <div className='row success_page' >
                <div className='col  ' >
                    {/* <Lottie options={defaultOptions} height={400} width={400}  /> */}
                    <img className='lottie_img' src="images/sucess/success.gif" alt='' />
                    <h3 className='mb-5 success_text'> Your Form Submitted SuccessFully ! </h3>
                    <Link to="/" className="success_link" >Go Back</Link>
                </div>
            </div>
        </div>
    )
}

export default SuccessPage